export enum FacetDataType {
  Text = 'Text',
  // eslint-disable-next-line id-blacklist
  Boolean = 'Boolean',
  Category = 'Category',
  CategorySingle = 'CategorySingle',
  Date = 'Date',
  DateRange = 'DateRange',
  Numeric = 'Numeric',
  Typeahead = 'Typeahead',
  TypeaheadSingle = 'TypeaheadSingle'
}
